/**
 * SessionTimeoutType Result Types
 *
 */
export enum SessionTimeoutType {
	LOGOUT = 'logout',
	KEEP = 'keep',
	IGNORED = 'ignored'
}
